module.exports = __webpack_public_path__ + "img/management.d70947a3.svg";